{
  "data.accruedInterest": "Vedhængende rente",
  "data.calculatedCompensation": "Beregnet kompensation",
  "data.changeMethod": "Afdragsmetode",
  "data.compensationAmount": "Kompensationsbeløb",
  "data.compensationAmount.ExtraRepayment.tooltip": "Den forholdsmæssige forskel mellem indfrielsesværdi og nominel restgæld ift. det ekstraordinære afdrag",
  "data.compensationAmount.FullRedemption.tooltip": "Forskel mellem indfrielsesværdi og nominel restgæld",
  "data.constructionCredit.notionalAmount": "Kredittræk",
  "data.credit.paymentAmount": "Beløb",
  "data.creditAmount": "Kredittræk",
  "data.currency": "Valuta",
  "data.currentNotionalAmount": "Aktuel restgæld",
  "data.EarlyTermination": "$t(data:data.maturityReduction)",
  "data.eventDueDateOnTerm": "Afdragsdato",
  "data.eventDueDateOutsideTerm": "Afdragsdato (uden for termin)",
  "data.fixedInterestRate": "Fastsat rentesats",
  "data.individualCompensationAmount": "Individuelt fastsat kompensationsbeløb",
  "data.interestConditionExpiryDate": "Udløb af renteaftale",
  "data.interestConvention": "Rentekonvention",
  "data.interestRate": "Rente",
  "data.leasingPayment": "Leasingydelse",
  "data.margin": "Bidrag",
  "data.marginRate": "Aktuel bidragssats",
  "data.maturityDate": "Udløbsdato",
  "data.maturityReduction": "$t(enums:changeMethod.ReducedTimeToMaturity)",
  "data.MaturityReduction": "$t(data:data.maturityReduction)",
  "data.newMaturityDate": "Ny udløbsdato",
  "data.newNotionalAmount": "Ny restgæld",
  "data.notAvailable": "Ikke tilgængelig",
  "data.notified": "Adviseret",
  "data.notified.short": "Adv.",
  "data.notionalAmount": "Restgæld",
  "data.notionalAmountAtInterestAgreement": "Restgæld ved renteaftale",
  "data.notionalAmountOnValueDate": "Restgæld før afdrag",
  "data.payment": "Ydelse",
  "data.paymentAmount": "Afdragsbeløb",
  "data.paymentReduction": "Ydelsesreduktion",
  "data.PaymentReduction": "$t(data:data.paymentReduction)",
  "data.paymentReduction.tooltip": "Reduktion i første ydelse efter afdrag",
  "data.paymentTypeString": "Betalingstype",
  "data.redemptionRepayAmount": "Beløb til indfrielse",
  "data.repayment": "Afdrag",
  "data.repaymentDate": "Valørdato",
  "data.startDate": "Startdato",
  "data.timeToMaturityReduction": "Løbetidsreduktion",
  "data.spread": "KK tillæg",
  "data.cheapest": "Billigst",
  "data.toMaturity": "Hele løbetiden",
  "data.newInterestAgreement.startDate": "Start på renteaftale",
  "data.newInterestAgreement.date": "Dato for ny renteaftale",
  "data.newInterestAgreement.endDate": "Udløb af renteaftale",
  "data.newInterestAgreement.fixedInterestYears": "Rentebinding",
  "data.newInterestAgreement.interestRate": "Aktuel rentesats",
  "data.newInterestAgreement.spread": "Heraf KK tillæg",
  "data.newInterestAgreement.effectiveInterestRate": "Effektiv rentesats",
  "data.newInterestAgreement.marginRate": "Aktuel bidragssats"
}
